import Model from 'src/app/core/models/model';

export default class PondSummaryReportModel extends Model {
  filename: string;
  abw?: number;
  Animals?: number;
  count?: number;
  culture_start_date?: string;
  cumulative_feed?: number;
  density?: string;
  density_weight?: string;
  DOC?: string;
  farm_site_id?: string;
  fcr?: string;
  fcr_weight?: string;
  growth_weight?: string;
  harvest_dates?: string;
  harvest_mode?: string;
  index?: number;
  pondID?: number;
  pond_culture_id?: string;
  pond_name?: string;
  pond_size?: number;
  Rank?: number;
  section_name?: string;
  sr?: string;
  sr_weight?: string;
  stocking_count?: number;
  total_biomass?: number;
  weight?: number;
  business_id?: string;
  ponduse: number;
  person_id: string;

  constructor() {
    super();
  }
}
